import { render, staticRenderFns } from "./WordsChange.vue?vue&type=template&id=1a4b9a54&scoped=true&"
import script from "./WordsChange.vue?vue&type=script&lang=js&"
export * from "./WordsChange.vue?vue&type=script&lang=js&"
import style0 from "./WordsChange.vue?vue&type=style&index=0&id=1a4b9a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b9a54",
  null
  
)

export default component.exports